import React from 'react';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridColumn,
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { GetSymphonyClientDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import { useTranslation } from '../../../common/hooks/useTranslation';

interface SymphonySearchProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  onRowClick?: (key: string) => Promise<void> | void | undefined;
  refresh: boolean;
}

export const symphonyForGrid = (symphonyClient: GetSymphonyClientDto) => {
  return {
    key: symphonyClient.id,
    values: {
      'symphonyClient.code': symphonyClient.code,
      'company.name': symphonyClient.company.name,
    },
    isInactive: !symphonyClient.active,
  };
};

export const SymphonySearch: React.FC<SymphonySearchProps> = props => {
  const { t, tk } = useTranslation('fvsLng');

  const columns: GridColumn[] = [
    { header: t(tk.common.company), property: 'company.name' },
    { header: t(tk.symphony.code), property: 'symphonyClient.code' },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      refresh={props.refresh}
      initialOrderColumn="company.name"
      availablePageSizes={[10, 20, 50]}
      emptyGridMessage={t(tk.symphony.noSymphonyForClient)}
      onRowClick={props.onRowClick}
      withHistory={true}
    />
  );
};
